/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetBlockedCompaniesResponseAllOf,
    GetBlockedCompaniesResponseAllOfFromJSON,
    GetBlockedCompaniesResponseAllOfFromJSONTyped,
    GetBlockedCompaniesResponseAllOfToJSON,
} from './GetBlockedCompaniesResponseAllOf';
import {
    GetBlockedCompaniesResponseAllOfData,
    GetBlockedCompaniesResponseAllOfDataFromJSON,
    GetBlockedCompaniesResponseAllOfDataFromJSONTyped,
    GetBlockedCompaniesResponseAllOfDataToJSON,
} from './GetBlockedCompaniesResponseAllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface GetBlockedCompaniesResponse
 */
export interface GetBlockedCompaniesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetBlockedCompaniesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetBlockedCompaniesResponse
     */
    message: string;
    /**
     * 
     * @type {GetBlockedCompaniesResponseAllOfData}
     * @memberof GetBlockedCompaniesResponse
     */
    data: GetBlockedCompaniesResponseAllOfData;
}

export function GetBlockedCompaniesResponseFromJSON(json: any): GetBlockedCompaniesResponse {
    return GetBlockedCompaniesResponseFromJSONTyped(json, false);
}

export function GetBlockedCompaniesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBlockedCompaniesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': GetBlockedCompaniesResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetBlockedCompaniesResponseToJSON(value?: GetBlockedCompaniesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': GetBlockedCompaniesResponseAllOfDataToJSON(value.data),
    };
}

